import { Badge } from '@/components/ui/badge'
import type { InviteStatus } from '@/types'

interface InviteStatusBadgeProps {
  status: InviteStatus
}

const labels: Record<Exclude<InviteStatus, 'active' | 'unknown'>, string> = {
  invited: 'Invited',
  reset_required: 'Reset required',
  disabled: 'Disabled',
}

const tooltips: Record<Exclude<InviteStatus, 'active' | 'unknown'>, string> = {
  invited: 'User has been invited but has not signed in yet.',
  reset_required: 'Cognito has forced a password reset for this user.',
  disabled: 'This user account is disabled.',
}

const variants: Record<
  Exclude<InviteStatus, 'active' | 'unknown'>,
  'secondary' | 'outline'
> = {
  invited: 'secondary',
  reset_required: 'secondary',
  disabled: 'outline',
}

export function InviteStatusBadge({ status }: InviteStatusBadgeProps) {
  if (status === 'active' || status === 'unknown') {
    return null
  }
  return (
    <Badge variant={variants[status]} title={tooltips[status]}>
      {labels[status]}
    </Badge>
  )
}
